module.exports = __webpack_public_path__ + "static/img/logo.d6d8fb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/logo.jpg
// module id = x2Ph
// module chunks = 1